/**
 * Stock Remnant Inventory API Service
 */

import { apiClient } from '../client';
import type {
  ApiResponse,
  StockItem,
  StockItemDetail,
  StockItemCreateRequest,
  StockItemUpdateRequest,
  StockItemCreateResult,
  StockListResponse,
  StockOptions,
} from '../../types';

const API_PREFIX = '/api/saiens/stock';

interface StockListParams {
  offset?: number;
  limit?: number;
  status?: string;
  brand_code?: string;
  search?: string;
  warehouse_location?: string;
}

/**
 * Get paginated list of stock items
 */
export async function getStockItems(
  params: StockListParams = {}
): Promise<ApiResponse<StockListResponse>> {
  const response = await apiClient.get<ApiResponse<StockListResponse>>(
    `${API_PREFIX}/items`,
    { params }
  );
  return response.data;
}

/**
 * Create a new stock item
 */
export async function createStockItem(
  data: StockItemCreateRequest
): Promise<ApiResponse<StockItemCreateResult>> {
  const response = await apiClient.post<ApiResponse<StockItemCreateResult>>(
    `${API_PREFIX}/items`,
    data
  );
  return response.data;
}

/**
 * Get a single stock item detail
 */
export async function getStockItem(
  id: number
): Promise<ApiResponse<StockItemDetail>> {
  const response = await apiClient.get<ApiResponse<StockItemDetail>>(
    `${API_PREFIX}/items/${id}`
  );
  return response.data;
}

/**
 * Update a stock item
 */
export async function updateStockItem(
  id: number,
  data: StockItemUpdateRequest
): Promise<ApiResponse<StockItem>> {
  const response = await apiClient.put<ApiResponse<StockItem>>(
    `${API_PREFIX}/items/${id}`,
    data
  );
  return response.data;
}

/**
 * Get dropdown options for stock forms
 */
export async function getStockOptions(): Promise<ApiResponse<StockOptions>> {
  const response = await apiClient.get<ApiResponse<StockOptions>>(
    `${API_PREFIX}/options`
  );
  return response.data;
}
